import {SmallLoader, Tile} from '@kit';

import React from 'react';

import {cls, getApolloError, imageUrl, variantSrcSet} from '../../components/utils';
import {useGameMapsQuery} from '../../generated/types';

import pageCss from '../../components/common.module.css';
import css from './maps-page.module.css';

type Props = {
	limit?: number;
	/** плитки поуже: на главной три в ряд, как статьи дня и приключения */
	compact?: boolean;
};

export const MapGrid: React.FC<Props> = ({limit, compact}) => {
	const {data, loading, error} = useGameMapsQuery({ssr: true});
	const maps = (data?.gameMaps || []).slice(0, limit);

	if (error) return <div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>;

	if (loading && !maps.length) {
		return (
			<div className={pageCss.fullSizeBlock}>
				<SmallLoader />
			</div>
		);
	}

	return (
		<ul className={cls(css.grid, compact && css.compact)}>
			{maps.map((map) => (
				<li key={map.id}>
					<Tile
						route="map"
						params={{id: map.id}}
						appearance="poster"
						media={
							<span className={css.preview}>
								{map.preview && (
									<img
										className={css.previewImage}
										src={imageUrl(map.preview, 900)}
										srcSet={variantSrcSet(map.preview)}
										sizes="(max-width: 600px) 90vw, 420px"
										alt=""
										loading="lazy"
									/>
								)}
							</span>
						}
						title={map.title}
					/>
				</li>
			))}
		</ul>
	);
};
